import { Observable } from "rxjs";
import HttpService from "./HttpService"; 
import { url } from "./APIEndPoints";
import { IAPIResponse } from "@mindmemobile/mm-shared-global"; 
import { IAPICountryWithStateModel } from "../interfaces/IAPICountryModel";

class CountryService {
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  getCountriesWithState(): Observable<
    IAPIResponse<IAPICountryWithStateModel[]>
  > {
    return this.httpService.get<IAPIResponse<IAPICountryWithStateModel[]>>(
      url.getCountriesWithState
    );
  }
}
export default new CountryService();
